import UserLogin from '@/components/UserLogin'

export const namespaced = true

export const state = () => ({
  loginInfo: null,
  popularizeSource: null
})

export const getters = {
  /**
   * 是否登录
   * @param state
   * @return {boolean}
   */
  isLogin: state => {
    let _isLogin = false

    if (state.loginInfo && state.loginInfo.token) {
      _isLogin = true
    }

    return _isLogin
  },

  /**
    * 推广来源
    */
  popularizeSource: state => {
    return state.popularizeSource
  }
}

export const mutations = {
  /**
   * 设置登录信息
   * @param state
   * @param {Object} loginInfo 登录信息
   */
  setLoginInfo(state, loginInfo) {
    state.loginInfo = loginInfo
  },
  /**
  * 设置推广来源信息
  */
  setPopularizeSource(state, sourceId) {
    state.popularizeSource = sourceId
  }
}

export const actions = {
  /**
   * 登录
   */
  login() {
    UserLogin.show()
  },
  /**
   * 退出登录
   */
  logout({ commit }) {
    commit('setLoginInfo', null)
    commit('setPopularizeSource', null)
    commit('user/setUserInfo', null, { root: true })
    commit('user/setAuthorInfo', null, { root: true })
    history.go(0)
  },
  /**
   * 退出登录
   */
  clearAuthInfo({ commit }) {
    commit('setLoginInfo', null)
    commit('setPopularizeSource', null)
    commit('user/setUserInfo', null, { root: true })
    commit('user/setAuthorInfo', null, { root: true })
  },
  ensureLogin({ dispatch, getters }, callback) {
    if (!getters.isLogin) {
      const next = () => {
        dispatch('login')
      }

      if (callback) {
        callback(next)
      } else {
        next()
      }
    }

    return getters.isLogin
  }
}
